import { createStore } from "vuex";

import InfoReqeuestStore from "@LandingPage/Scripts/Stores/InfoReqeuestStore";

export const store = createStore({
    modules: {
        infoRequestStore: InfoReqeuestStore
    }
});
